import { TypedDocumentNode, gql } from '@apollo/client';
import { FormattedMessage } from 'react-intl';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { useIsDesktopAndAbove } from '@sorare/core/src/hooks/device/useIsDesktopAndAbove';

import { LeaderboardOverview } from 'components/rivals/ArenaPage/LeaderboardOverview';
import { SeasonProgressGraphWithLegend } from 'components/rivals/seasons/SeasonProgressGraphWithLegend';
import { SeasonsHistory } from 'components/rivals/seasons/SeasonsHistory';

import { ProfileLayoutArena_rivalsRoot } from './__generated__/index.graphql';

type Props = {
  rivalsRoot: Nullable<ProfileLayoutArena_rivalsRoot>;
  forceLeaderboardOverview?: boolean;
};
export const ProfileLayoutArena = ({
  rivalsRoot,
  forceLeaderboardOverview,
}: Props) => {
  const isDesktopAndAbove = useIsDesktopAndAbove();

  if (!rivalsRoot) {
    return null;
  }

  const pastSeasons = rivalsRoot.pastSeasons.nodes;
  const { manager } = rivalsRoot;

  return (
    <Vertical gap={2}>
      {(!isDesktopAndAbove || forceLeaderboardOverview) && manager && (
        <LeaderboardOverview
          manager={manager}
          customTitle={
            <FormattedMessage
              id="LeaderboardOverview.title.current"
              defaultMessage="Current Leaderboard"
            />
          }
        />
      )}
      <SeasonProgressGraphWithLegend manager={manager} />
      <SeasonsHistory pastSeasons={pastSeasons} />
    </Vertical>
  );
};

ProfileLayoutArena.fragments = {
  rivalsRoot: gql`
    fragment ProfileLayoutArena_rivalsRoot on FootballRivalsRoot {
      id
      pastSeasons(first: 5) {
        nodes {
          slug
          id
          ...SeasonsHistory_footballRivalsSeason
        }
      }
      manager(userSlug: $userSlug) {
        id
        ...SeasonProgressGraphWithLegend_footballRivalsPublicManagerInterface
        ...LeaderboardOverview_footballRivalsManager
      }
    }
    ${SeasonsHistory.fragments.footballRivalsSeason}
    ${SeasonProgressGraphWithLegend.fragments
      .footballRivalsPublicManagerInterface}
    ${LeaderboardOverview.fragments.footballRivalsManager}
  ` as TypedDocumentNode<ProfileLayoutArena_rivalsRoot>,
};
